import { Controller } from '@hotwired/stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['textField', 'submitButton', 'errorMessage']
  static values = {
    errorMessage: String
  }

  initialize () {
    this.form = this.element
    this.formSubmitable = false

    this._listenTextFieldHotkeys()
  }

  handleTextFieldInput () {
    const valueLength = this.textFieldTarget.value.replace(/\s+/g, '').length
    this.formSubmitable = valueLength > 0
    this._setFormSubmitting()
  }

  handleFormPreSubmit () {
    this.formSubmitable = false

    this._setFormSubmitting()
  }

  handleFormSuccess (event) {
    const [data, status, xhr] = event.detail
    this._resetFormState()
    this._handleFormSuccessResponse(xhr.response)
  }

  handleFormError (event) {
    const [data, status, xhr] = event.detail
    this._handleFormErrorResponse(xhr.response)
  }

  // -----------------------------------------------------------------------------------------------

  _listenTextFieldHotkeys () {
    this.textFieldTarget.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 && event.metaKey) {
        this.handleTextFieldInput()

        if (this.formSubmitable) {
          Rails.fire(this.form, 'submit')
        }
      }
    })
  }

  _handleFormErrorResponse (response) {
    this.errorMessageTarget.innerHTML = `
      <div class="message message_error mb-2">${this.errorMessageValue}</div>
    `
  }

  _resetFormState () {
    this.formSubmitable = false
    this._clearTextField()
    this._clearErrorMessage()
    this._setFormSubmitting()
  }

  _clearErrorMessage () {
    try {
      this.errorMessageTarget.removeChild(this.errorMessageTarget.firstChild)
    } catch (e) {}
  }

  _clearTextField () {
    this.textFieldTarget.value = ''
  }

  _setFormSubmitting () {
    this.submitButtonTarget.disabled = !this.formSubmitable
  }
}
